import { CreateCategory } from '@app/pages/b2b/QuestionsLibrary/components';
import { CategoryType } from '@data/sdk/match';
import { ClassificationTable } from '../components';
import { useQuestionClassification } from '../hooks';

const QuestionTags = () => {
  const {
    current,
    pageSize,
    isLoading,
    questionId,
    categories,
    isCreateCategoryOpen,
    handleTableChange,
    openCreateCategory,
    closeCreateCategory,
  } = useQuestionClassification(CategoryType.Tag);

  return (
    <>
      <ClassificationTable
        type={CategoryType.Tag}
        createCategory
        current={current}
        pageSize={pageSize}
        isLoading={isLoading}
        total={categories?.count || 0}
        categories={categories?.items}
        handleTableChange={handleTableChange}
        openCreateCategory={openCreateCategory}
      />

      <CreateCategory
        open={isCreateCategoryOpen}
        close={closeCreateCategory}
        questionId={questionId}
        type={CategoryType.Tag}
      />
    </>
  );
};

export default QuestionTags;
